import { TreeViewBaseItem } from '@mui/x-tree-view';

export enum RootNodesIds {
  CurrentUserPreferences = 'current-user-prefs',
  PrimaryUserPreferences = 'primary-user-prefs',
  CurrentPracticePreferences = 'current-practice-prefs',
  RollloutConfigs = 'rollout-configs',
  CurrentUser = 'current-user',
  PrimaryUser = 'primary-user',
  CurrentPractice = 'current-practice',
  VisitTypes = 'vts',
  VisitTypesMemberships = 'vtms',
  CalendarBlocks = 'calendar-blocks',
  Features = 'configuration-sets',
}

export enum InspectorConsoleSource {
  Inspector = 'inspector',
  GlobalError = 'global-error',
  Toast = 'toast',
  RTK = 'rtk',
  ConsoleLog = 'console-log',
}

export type InspectorConsoleLine = {
  source: InspectorConsoleSource;
  timestampISO?: string;
  message: string;
  messageValue?: unknown;
  data?: object;
};

export type TreeItemType = {
  id: string;
  label: string;
  content?: React.ReactNode;
  icon?: React.ReactNode;
  iconColor?: string;
  textColor?: string;
  value?: unknown;
  children?: TreeNode[];
};

export type TreeNode = TreeViewBaseItem<TreeItemType>;
